import { modelFilters } from "../filters";
import { ModelNames } from "../models";
import { QueryComposer } from "./types";

const partnerQuery: QueryComposer = (filters) => {
  const composedFilters: any = [{ role: "consultant" }];
  if (filters.selectedStatusList?.length) {
    const [stageFilterValue, statusFilterValue] = filters.selectedStatusList;
    const stageFilter = modelFilters[ModelNames.PARTNERS].find(
      ({ value }) => value === stageFilterValue
    );
    if (stageFilter) {
      composedFilters.push(stageFilter.filter);
    }
    if (statusFilterValue) {
      const statusFilter = stageFilter?.nestedFilters?.find(
        ({ value }) => value === statusFilterValue
      );
      if (statusFilter) composedFilters.push(statusFilter.filter);
    }
  }
  if (filters.searchTerm) {
    composedFilters.push({
      $or: [
        { nome: { $regex: filters.searchTerm, $options: "i" } },
        { email: { $regex: filters.searchTerm, $options: "i" } },
        { celular: { $regex: filters.searchTerm, $options: "i" } },
        { cpfCnpj: { $regex: filters.searchTerm, $options: "i" } },
        { area: { $regex: filters.searchTerm, $options: "i" } },
        { estado: { $regex: filters.searchTerm, $options: "i" } },
        { cidade: { $regex: filters.searchTerm, $options: "i" } },
      ],
    });
  }

  if (!composedFilters.length) {
    return {};
  } else {
    return composedFilters;
  }
};

export default partnerQuery;
